export default {
    '/about/': 'About',
    '/privacy-policy/': 'PrivacyPolicy',
    '/terms-conditions/': 'TermsConditions',
    '/contact-us/': 'ContactUs',
    '/samf-talent-search/': 'SAMFTalentSearch',
    '/logic-day/': 'LogicDay',
    '/daily-puzzle/': 'IFrameDailyPuzzle',
}